import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=0097f077&scoped=true"
import script from "./detailDialog.vue?vue&type=script&lang=js"
export * from "./detailDialog.vue?vue&type=script&lang=js"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=0097f077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0097f077",
  null
  
)

export default component.exports